export const pageHeight = `calc(100vh - 80px)`

export const pageColor = `#e2e0e4`

export const pagePadding = {
  md: `0 2rem`,
  xs: `0 2.5rem`,
}
